import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ManagedDepartment } from '../types';

/**
 * Which department a write (import, create, upload) is for.
 *
 * Single-department users always get their own department. A user who manages
 * several departments must choose one; nothing is selected by default so data
 * never lands on the root by accident.
 */
export function useTargetDepartment(initialId?: number) {
  const { user } = useAuth();
  const departments: ManagedDepartment[] = user?.managed_departments ?? [];
  const isMultiDepartment = departments.length > 1;
  const ownId: number | null = user?.profile?.organization ?? null;

  const [selectedId, setSelectedId] = useState<number | null>(
    initialId !== undefined && departments.some((d) => d.id === initialId) ? initialId : null,
  );

  return {
    isMultiDepartment,
    departments,
    departmentId: isMultiDepartment ? selectedId : ownId,
    setDepartmentId: setSelectedId,
  };
}
